import styled from 'styled-components';

export interface Props {
  width?: number;
  right?: number;
  top?: number;
  align?: string;
  fontSize?: number;
  left?: number;
}

const Table: any = styled.table`
  color: #464646;
  width: 100%;
  border-spacing: 0px;
`;

Table.Head = styled.thead`

`;

Table.HeadRow = styled.tr`
  background-color: #ffffff;
`;

Table.HeadCell = styled.th`
  padding: 8px;
  font-size: 0.950rem;
  font-weight: bold;
  text-align: center; 
  min-width: ${(props: Props) => `${props.width || 100}px`}; 
`;

Table.HeadCell1 = styled.th`
  padding-top: 8px;
  padding-left: 4px;
  font-size: 1.2rem;
  font-weight: 400;
  text-align: left;
  width: 12%;
  min-width: 70px;
`;

Table.HeadCell2 = styled.th`
  padding-top: 8px;
  font-size: 1.2rem;
  font-weight: 400;
  text-align: left;
  width: ${(props: Props) => `${props.width || 22}%`}; 
  min-width: 90px;
`;

Table.HeadCell3 = styled.th`
  padding-top: 8px;
  padding-left: 4px;
  font-size: 1.2rem;
  font-weight: 400;
  text-align: left;
  width: 38%;
  min-width: 120px;
`;

Table.Body = styled.tbody``;

Table.Row = styled.tr`
    background-color: white;
`;

Table.Cell = styled.td`
  font-weight: 1rem; 
  padding: 4px 0px;
  width: auto;
  height: 52px;
  font-size: ${(props: Props) => `${props.fontSize || '16'}px`};
  text-align: ${(props: Props) => `${props.align || 'center'}`};
  padding-right: ${(props: Props) => `${props.right || 0}px`};
  padding-left: ${(props: Props) => `${props.left || 0}px`};
  padding-top: ${(props: Props) => `${props.top || 0}px`}; 
  :first-child {
    border-top-left-radius: 18px;
    border-bottom-left-radius: 18px;
  }

  :last-child {
    border-top-right-radius: 18px;
    border-bottom-right-radius: 18px;
  }
`;

export default Table;
